import {Controller} from 'stimulus'
import {Turbo} from "@hotwired/turbo-rails";

export default class extends Controller {
  switchMonth(event) {
    const target = event.currentTarget;
    Turbo.visit(`?month=${target.value}`)
  }
}
